const USER_LOCAL_STATE_KEY = 'userLocalState';

export const getDefaultUserLocalState = () => {
    return {
        theme: 'dark',
        lastProjectId: '',
    };
}

export const getLocalState = () => {
    let data;

    try {
        const localItem = localStorage.getItem(USER_LOCAL_STATE_KEY);
        if (localItem) {
            data = JSON.parse(localItem);
        }
    } catch (err) {
        console.error(err);
    }

    return data || getDefaultUserLocalState();
};

export const updateLocalState = (data) => {
    const currentState = getLocalState();
    const newState = {...currentState, ...data};

    try {
        localStorage.setItem(USER_LOCAL_STATE_KEY, JSON.stringify(newState));
    } catch (err) {
        console.error(err);
    }

    return newState;
};